import { createContext } from 'react';

import { useNotNullableContext } from '../hooks';

export type CopyContext = {
  shareModal: {
    heading: string;
    description: string;
  };
  supportersList: {
    noSupportersMessage: string;
  };
  helmet: {
    title: string;
    ogTitle: string;
    description: string;
    twitterDescription: string;
  };
};

export const CopyContext = createContext<CopyContext | null>(null);

export const CopyContextProvider = CopyContext.Provider;

export const useCopyContext = () => useNotNullableContext(CopyContext);
